
                export default function (Component) {
                    Component.__source = "library/components/VabHelper/index.vue"
                }
            